module.exports = __webpack_public_path__ + "static/media/settings-icon.d6e566ed.svg";